import React from 'react';
import {message, Tooltip} from 'antd';
import {Icon} from 'libs';
import {LangConsumer} from 'utils/LangProvider';
import {isEmptyRect} from '../../../common';
import plugin from 'plugin';
import './index.less';

class MinDetectCmp extends React.Component {
    constructor (props) {
        super(props);
        this.DetectId = 0; //最小聚集区域主图像id
    }
    componentDidMount () {
    }
    // 绘制最小聚集区域
    drawMinDetect = () => {
        let {$t, enable, drawingType} = this.props;
        if (drawingType && drawingType !== '') {
            // 当前正在绘制规则
            message.error($t('com.PleaseDrawShapeTip'));
            return;
        }
        if (!enable) {
            message.error($t('com.RuleIsntEnableTip'));
            return;
        }
        this.drawTarget();
        this.props.setBtnStatus(this.props.btnIndex[0]);
        this.props.setDrawingExcludeStatus && this.props.setDrawingExcludeStatus(false);
    }
    drawTarget = () => {
        let {$t, containerID, enable, rule, setSelectShape} = this.props;
        let minDetect = rule.Config.MinDetectRect;
        if (enable) {
            plugin.DeleteAllVideoAnalyseShape(containerID).then(() => { // 先清空容器
                if (isEmptyRect(minDetect)) {
                    plugin.SetVideoAnalyseContainerTip(containerID, $t('com.PleaseDrawShapeTip'));
                    plugin.CreateMainVideoAnalyseShape(containerID, 'MinDetect', 'Rectangle', '', '', '').then((shapeId) => {
                        this.DetectId = shapeId;
                        setSelectShape(this.DetectId, 'MinDetect');
                    });
                } else {
                    plugin.CreateMainVideoAnalyseShape(containerID, 'MinDetect', 'Rectangle', '', JSON.stringify({'Rectangle': minDetect}), '').then((shapeId) => {
                        this.DetectId = shapeId;
                        plugin.EnableVideoAnalyseShape(containerID, shapeId, true);
                        setSelectShape(this.DetectId, 'MinDetect');
                    });
                }
            });
        }
    }
    render () {
        let {$t, btnStatus} = this.props;
        return (
            <div>
                <div
                    className='icon'
                    onClick={() => {
                        if (plugin.isInStalled) {
                            this.drawMinDetect();
                        }
                    }}
                    style={{color: btnStatus[this.props.btnIndex[0]] ? '#1890FF' : ''}}
                >
                    <Tooltip placement='right' title={$t('ivs.MinGatherRegion')}>
                        <Icon type="MinDetectRect"/>
                    </Tooltip>
                </div>
            </div>
        );
    }
}

export default LangConsumer(MinDetectCmp);